// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1n5Ux","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__ZjlUF"};